// Auto generated file, do not manually modify!
// com.hotpads.rins.client.enums.UpsellTrackingIdType

export enum UpsellTrackingIdType {
  ADDRESS = 'ADDRESS',
  APPLICATION_ID = 'APPLICATION_ID',
  LEASE_ID = 'LEASE_ID',
  LISTING_ALIAS = 'LISTING_ALIAS',
}

export const UpsellTrackingIdType_values = [
  UpsellTrackingIdType.ADDRESS,
  UpsellTrackingIdType.APPLICATION_ID,
  UpsellTrackingIdType.LEASE_ID,
  UpsellTrackingIdType.LISTING_ALIAS,
] as const;
